import { Loader2 } from "lucide-react";
import { cn } from "../../lib/cn.js";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 aria-hidden className={cn("h-4 w-4 animate-spin", className)} />;
}

export function FullPageSpinner({ label = "加载中…" }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[200px] items-center justify-center text-text-secondary">
      <Spinner className="mr-2 h-4 w-4" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
